import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import muiThemeV0 from 'appDir/lib/muiThemeV0';
import { CloudinaryContext } from 'cloudinary-react';

import createStore from './store';
import routes from '../routes/routes';

const appClient = (props, railsContext) => {
  const store = createStore(props);

  return (
    <Provider store={store}>
      <MuiThemeProvider muiTheme={muiThemeV0}>
        <CloudinaryContext cloudName={railsContext.cloudinaryCloudName}>
          <BrowserRouter>{routes}</BrowserRouter>
        </CloudinaryContext>
      </MuiThemeProvider>
    </Provider>
  );
};

export default appClient;
